"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuckDBSqlGenerator = void 0;
const base_1 = require("./base");
class DuckDBSqlGenerator extends base_1.BaseSqlGenerator {
    quoteIdentifier(name) {
        return `"${name.replace(/"/g, '""')}"`;
    }
    generateModulo(left, right) {
        return `(${left} % ${right})`;
    }
}
exports.DuckDBSqlGenerator = DuckDBSqlGenerator;
//# sourceMappingURL=duckdb.js.map